module.exports = __webpack_public_path__ + "assets/img/voice-stop.307d2379.png";